import Constants from '../../../utils/CommonConstants';

export default class CatalogService {
    static $inject = [ '$http', 'ConfigurationService', 'cartonomyConfig' ];

    constructor(httpService, configurationService, cartonomyConfig) {

        this._httpService = httpService;
        this._configurationService = configurationService;
        this._urlBase = cartonomyConfig.ApiV2 + 'catalog/';
        this._cachedSuperCategoryProducts = {};

    }

    getAllCategories() {

        if (this._allCategories) {
            return this._allCategories;
        }

        this._allCategories = this._httpService
                                  .get(this._urlBase + 'categories')
                                  .then(res => res.data);

        return this._allCategories;
    }

    getCategory(categoryId) {
        return this._httpService
                   .get(this._urlBase + 'categories/' + categoryId)
                   .then(res => res.data);
    }

    getDefaultCategory() {
        return this._configurationService.getItem('defaultCategory');
    }

    getProductsInCategory(categoryId) {
        return this._httpService
                   .get(this._urlBase + 'categories/' + categoryId + '/products')
                   .then(res => res.data);
    }

    getProductsBySuperCategory(categoryId, offset, limit) {

        limit = typeof limit === "undefined" ? Constants.Pagination.PAGE_LIMIT : limit;
        offset = typeof offset === "undefined" ? 0 : offset;

        var key = categoryId + ":" + offset + ":" + limit;

        if (this._cachedSuperCategoryProducts[ key ]) {
            return new Promise(resolve => {
                resolve(this._cachedSuperCategoryProducts[ key ]);
            });
        }

        return this._httpService.get(this._urlBase + 'supercategory/' + categoryId + '/products/' + offset + '/' + limit)
                   .then(res => {
                       this._cachedSuperCategoryProducts[ key ] = res.data;
                       return res.data;
                   });
    }

    getProduct(productId) {
        return this._httpService.get(this._urlBase + 'product/' + productId)
                   .then(res => res.data);
    }

    searchProducts(searchString, page) {

        var catalogSearchParams = {
            SearchString: searchString,
            MaxProductsPerPage: Constants.Pagination.PAGE_LIMIT,
            CurrentPage: page
        };

        return this._httpService.post(this._urlBase + 'search', catalogSearchParams)
                   .then(res => res.data);
    }
}


// WEBPACK FOOTER //
// ./src/modules/catalog/services/CatalogService.js